// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alumni-stories .alumni-story-count {
    font-size: 13px;
    font-weight: 600;
    color: #0b3454;
    background: #f4f7fb;
    border-radius: 19px;
    padding: 6px 14px;
}

.alumni-story-row + .alumni-story-row {
    margin-top: 22px;
    padding-top: 22px;
    border-top: 1px solid #f0f0f0;
}

.alumni-story-top {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 16px;
    margin-bottom: 16px;
}

.alumni-story-top-main {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
}

.alumni-story-role {
    display: inline-flex;
    align-items: center;
    border-radius: 19px;
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 600;
}

.alumni-story-role.narrator {
    background: #e8f1ff;
    color: #1d4f91;
}

.alumni-story-role.protagonist {
    background: #fff6e0;
    color: #8a5a00;
}

.alumni-story-date {
    margin-left: auto;
    font-size: 13px;
    font-weight: 500;
    color: #6b7280;
}

.alumni-story-rating {
    display: inline-flex;
    align-items: center;
    gap: 1px;
    background: #fffbeb;
    border: 1px solid #f5d76e;
    border-radius: 19px;
    padding: 3px 10px 4px;
    font-size: 15px;
    line-height: 1;
    color: #e5e7eb;
    letter-spacing: 1px;
}

.alumni-story-rating .on {
    color: #f5b400;
}

.alumni-story-rating.empty {
    background: #f9fafb;
    border-color: #e5e7eb;
    color: #d1d5db;
}

.alumni-story-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 4px;
}

.alumni-story-tags span {
    background: #f3f4f6;
    color: #374151;
    border-radius: 6px;
    padding: 3px 8px;
    font-size: 12.5px;
    font-weight: 600;
}

.alumni-story-tags.markers span {
    background: #ffffff;
    border: 1px solid #d6e4f5;
    color: #1d4f91;
}

.alumni-story-empty {
    color: #646464;
    font-size: 16px;
}

.alumni-stories .btn-add-section {
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/features/alumni/alumni-profile/sections/AlumniStories.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".alumni-stories .alumni-story-count {\n    font-size: 13px;\n    font-weight: 600;\n    color: #0b3454;\n    background: #f4f7fb;\n    border-radius: 19px;\n    padding: 6px 14px;\n}\n\n.alumni-story-row + .alumni-story-row {\n    margin-top: 22px;\n    padding-top: 22px;\n    border-top: 1px solid #f0f0f0;\n}\n\n.alumni-story-top {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px 16px;\n    margin-bottom: 16px;\n}\n\n.alumni-story-top-main {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n}\n\n.alumni-story-role {\n    display: inline-flex;\n    align-items: center;\n    border-radius: 19px;\n    padding: 4px 12px;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.alumni-story-role.narrator {\n    background: #e8f1ff;\n    color: #1d4f91;\n}\n\n.alumni-story-role.protagonist {\n    background: #fff6e0;\n    color: #8a5a00;\n}\n\n.alumni-story-date {\n    margin-left: auto;\n    font-size: 13px;\n    font-weight: 500;\n    color: #6b7280;\n}\n\n.alumni-story-rating {\n    display: inline-flex;\n    align-items: center;\n    gap: 1px;\n    background: #fffbeb;\n    border: 1px solid #f5d76e;\n    border-radius: 19px;\n    padding: 3px 10px 4px;\n    font-size: 15px;\n    line-height: 1;\n    color: #e5e7eb;\n    letter-spacing: 1px;\n}\n\n.alumni-story-rating .on {\n    color: #f5b400;\n}\n\n.alumni-story-rating.empty {\n    background: #f9fafb;\n    border-color: #e5e7eb;\n    color: #d1d5db;\n}\n\n.alumni-story-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 4px;\n}\n\n.alumni-story-tags span {\n    background: #f3f4f6;\n    color: #374151;\n    border-radius: 6px;\n    padding: 3px 8px;\n    font-size: 12.5px;\n    font-weight: 600;\n}\n\n.alumni-story-tags.markers span {\n    background: #ffffff;\n    border: 1px solid #d6e4f5;\n    color: #1d4f91;\n}\n\n.alumni-story-empty {\n    color: #646464;\n    font-size: 16px;\n}\n\n.alumni-stories .btn-add-section {\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
